<template>
    <div class="mod-container">
        <div v-for="(item, index) in dataList" :key="index">
            <div class="info-box" :class="selectIndex == index ? 'selected' : ''"
                 @click="onSelectTech(item, index)">
              <span class="tech-title" v-text="item.dictValue"></span>
              <span class="tech-desc" v-text="item.extraValue"></span>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        selectIndex: 0,
        selectItem: Object.assign({})
      }
    },
    props: {
      dataList: {
        type: [Object, Array],
        default: Object.assign({})
      }
    },
    created () {
    },
    methods: {
      onSelectTech (currentItem, targetIndex) {
        this.selectIndex = targetIndex
        localStorage.setItem('selectProductIndex', this.selectIndex)
        this.selectItem = currentItem
      }
    }
  }
</script>
<style scoped>
  .info-box {
    background: #FFFFFF;
    border-radius: 10px;
    margin: 10px 0;
    padding: 20px 0;
    text-align: center;
    border: 1px solid rgba(239, 238, 243, 1);
  }
  .selected {
    border: 1px solid #5878FA;
  }
  .selected span {
    color: #5878FA;
  }

  .info-box span {
      display: block;
  }
  .tech-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 22px;
  }
  .tech-desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 17px;
  }
</style>



// WEBPACK FOOTER //
// QualitativeTeach.vue?417834a4